const axiosInstance = require('axios');

const url = process.env.GATSBY_PAYMENT_API;
// const url = 'http://localhost:5000/calibrated-cxn/us-central1/api';

module.exports = async function fetchPayment(params) {
  try {
    const secret =
      typeof window === 'undefined' ? global.secret : window.idToken;
    const axios = axiosInstance.create({
      baseURL: url,
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${secret}`
      }
    });
    const { data } = await axios.post('/', params);
    return data;
  } catch (e) {
    throw e;
  }
};
